import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { data } from './data'

import cl from './Menu.module.scss'

export const Menu = () => {
	const pathname = usePathname()

	const liClasses = (link: string) => {
		return clsx(cl.li, {
			[cl.active]: link === pathname
		})
	}

	return (
		<ul className={cl.ul}>
			{data.map(item => (
				<li className={liClasses(item.link)} key={item.link}>
					<Link prefetch={false} href={item.link}>
						{item.title}
					</Link>
				</li>
			))}
		</ul>
	)
}
